import { useContext, useMemo } from 'react'
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { Context } from '../../context/AuthContext'

/**
 * Seletor de filial. Vira Autocomplete quando há muitas filiais e é
 * auto-selecionado/desabilitado quando o usuário só tem uma.
 */
const SelectSubCompany = ({ value, onChange, label = 'Filial', size = 'medium', sx }) => {
  const { subCompany } = useContext(Context)

  const options = useMemo(
    () => [...(subCompany || [])].sort((a, b) => a.name.localeCompare(b.name)),
    [subCompany]
  )

  const emit = nextValue => onChange && onChange({ target: { value: nextValue } })

  if (options.length > 5) {
    return (
      <FormControl sx={{ width: '100%', ...sx }} size={size}>
        <Autocomplete
          size={size}
          options={options}
          value={options.find(item => item.subCompanyId.trim() === value) || null}
          getOptionLabel={option => option.name.trim()}
          isOptionEqualToValue={(option, selected) => option.subCompanyId === selected.subCompanyId}
          onChange={(event, newValue) => emit(newValue ? newValue.subCompanyId.trim() : '')}
          noOptionsText="Nenhuma filial encontrada"
          renderInput={params => <TextField {...params} label={label} />}
        />
      </FormControl>
    )
  }

  return (
    <FormControl sx={{ width: '100%', ...sx }} size={size}>
      <InputLabel id="select-subcompany-label">{label}</InputLabel>
      <Select
        labelId="select-subcompany-label"
        label={label}
        value={value || ''}
        disabled={options.length === 1}
        onChange={event => emit(event.target.value)}
        MenuProps={{ PaperProps: { style: { maxHeight: 400 } } }}
      >
        {options.map(item => (
          <MenuItem value={item.subCompanyId.trim()} key={item.subCompanyId}>
            {item.name.trim()}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectSubCompany
